"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/App.css");
require("../styles/Link.css");
var _Back_icon = _interopRequireDefault(require("../assets/Back_icon.png"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : BackPage.js
* Description : Ce fichier contient la définition du composant BackPage 
*               Ce composant est un lien composé d'une icône '<-' et d'un texte
* Date de création : 23 septembre 2024
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */

/**
* AddItem : ce lien renvoi la page précédente 
*
* Type : composant 
*
* Parametres : 
*  - children -- texte affiché sur le lien
*  - path -- Url de la page à renvoyer
*/function BackPage(_ref) {
  var children = _ref.children,
    path = _ref.path;
  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactRouterDom.Link, {
      to: path,
      className: "link",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _Back_icon["default"],
        alt: "back_page_icon",
        className: "link-img"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "link-text",
        children: children
      })]
    })
  });
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
BackPage.propTypes = {
  path: _propTypes["default"].string
};
var _default = exports["default"] = BackPage;